import { InfoCircleOutlined } from "@ant-design/icons";
import { Pagination, Space, Table, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ApproveDesignationModal from "../modal/ApproveDesignationModal";
import ApprovePlanModal from "../modal/ApprovePlanModal";
import ApproveUnitModal from "../modal/ApproveUnitModal";
import ApproveUserModal from "../modal/ApproveUserModal";
import { LIMIT_PER_PAGE } from "../../helpers/constants";

function RejectedApprovalsTable(props) {
  const [userInfo, setUserInfo] = useState(false);
  const [unitInfo, setUnitInfo] = useState(false);
  const [planInfo, setPlanInfo] = useState(false);
  const [designationInfo, setDesignationInfo] = useState(false);
  const [data, setData] = useState("");
  const positionState = useSelector((state) => state.positionState.value);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(props.tableLoading);
  }, [props.tableLoading]);

  function openInfoModal(type) {
    if (type === "Unit") {
      setUnitInfo(true);
    } else if (type === "User") {
      setUserInfo(true);
    } else if (type === "Plan") {
      setPlanInfo(true);
    } else if (type === "Designation") {
      setDesignationInfo(true);
    }
  }
  const columns = [
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Details",
      dataIndex: "details",
      key: "details",
      render: (text, record) => <div>{text}</div>,
    },
    {
      title:
        positionState?.userRole?.name === "Manager" ? "Approver" : "Added by",
      dataIndex: "addedBy",
      key: "addedBy",
      render: (text, record) => (
        <div>
          {" "}
          {positionState?.userRole?.name === "Manager"
            ? record.approvedBy?.user?.firstName
            : record.requestBy?.user?.firstName}
        </div>
      ),
    },
    {
      title: "Added on",
      dataIndex: "addedOn",
      key: "addedOn",
      render: (text, record) => <div>{record.createdOn.slice(0, 10)}</div>,
    },

    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          <Tooltip title={"Info"}>
            <div
              onClick={() => {
                openInfoModal(record.type);
                setData(record);
              }}
              className="text-blue-500 hover:text-blue-600 cursor-pointer"
            >
              <InfoCircleOutlined />
            </div>
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Table
        loading={loading}
        columns={columns}
        dataSource={props.data?.approvals}
        pagination={false}
      />
      <div className="text-center mt-6">
        <Pagination
          onChange={(num) => {
            props.changePage(num);
            props.setRejectedPage(num);
          }}
          current={props.current}
          total={props.data?.totalCount || 0}
          pageSize={LIMIT_PER_PAGE}
        />
      </div>
      <ApproveUserModal
        visible={userInfo}
        handleCancel={() => {
          setUserInfo(false);
        }}
        data={data}
      />
      <ApproveUnitModal
        visible={unitInfo}
        handleCancel={() => setUnitInfo(false)}
        data={data}
      />
      <ApprovePlanModal
        visible={planInfo}
        handleCancel={() => setPlanInfo(false)}
        data={data}
      />
      <ApproveDesignationModal
        visible={designationInfo}
        handleCancel={() => setDesignationInfo(false)}
        data={data}
      />
    </>
  );
}

export default RejectedApprovalsTable;
